import Vue from 'vue';
import VueFileAgentPlugin from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';

Vue.component('VueFileAgent', VueFileAgentPlugin.VueFileAgent, VueFileAgentStyles);
